<template>
  <div>
    <el-select
      filterable
      clearable
      v-model="PaymentOrInvoice"
      placeholder="Descripcion Pagos/Facturas"
      @change="handlePaymentsSelection"
      v-bind="$attrs"
      size="mini"
      :loading="isLoading"
      :disabled="disabled"
    >
      <!-- <el-option :key="0" :value="0" label="Todos"></el-option> -->
      <el-option
        v-for="item in PaymentsAndInvoices"
        :key="item"
        :label="item"
        :value="item"
      ></el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: "PaymentsAndInvoicesSelector",
  props: {
    disabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },

  data() {
    return {
      PaymentOrInvoice: "",
      PaymentsAndInvoices: [],
      isLoading: false
    };
  },

  mounted() {
    this.GetPaymentsData();
  },

  methods: {
    async GetPaymentsData() {
      this.isLoading = true;

      await this.$http
        .get("/api/CalendarioFinanza/GetInvoicesAndPaymentsFilter")
        .then((resp) => {
          this.PaymentsAndInvoices = resp.data;
        })
        .catch((err) => {
          this.$message.error(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    handlePaymentsSelection(value) {
      this.$emit("PaymentSelected", value);
    }
  }
};
</script>

<style scoped></style>
